module.exports = __webpack_public_path__ + "static/aerial.fbda5f92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aerial.jpg
// module id = 1224
// module chunks = 65368489232520